export const ROUTES_MAP = {
  notFound: "*",
  landing: "/",
  checkoutReturn: "/streams/new",
  auth: {
    index: "/auth",
    login: "/auth/login",
    asUser: "/login/as-user",
    signup: "/auth/signup",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password",
  },
  dashboard: {
    index: "/dashboard",
    liveStreams: "/dashboard/live-streams",
    liveStreamDetails: (id: string) => `/dashboard/live-streams/${id}`,
    faqs: "/dashboard/faqs",
    logout: "/dashboard/logout",
    settings: {
      profile: `/dashboard/settings/profile`,
    },
    admin: {
      index: "/dashboard/admin",
      users: "/dashboard/admin/users",
      liveStreams: "/dashboard/admin/live-streams",
      blockedRegistrations: "/dashboard/admin/blocked-registrations",
      abuseIncidents: "/dashboard/admin/abuse-incidents",
    },
  },
};
